import { Button, Form, Input } from 'antd';
import styles from '../UserProfile.module.scss';

interface PersonalInfoFormProps {
  readOnly: boolean;
  editProfileUrl?: string;
}

export const PersonalInfoForm = ({ readOnly, editProfileUrl }: PersonalInfoFormProps) => {
  const isEditAvailable = !readOnly && editProfileUrl;
  return (
    <>
      <div className={styles.sectionHeader}>
        <div className={styles.registerTitle}>Personal information</div>
        {isEditAvailable && (
          <Button
            type="primary"
            id="UserProfile-EditPersonalInformation_Button"
            href={editProfileUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Edit
          </Button>
        )}
      </div>

      <Form.Item className={styles.registerFormItem} name="userId" label="E-mail">
        <Input id="UserProfile-UserId_Input" placeholder="" disabled autoComplete="no" />
      </Form.Item>

      <div className={styles.personalFormNameField}>
        <Form.Item className={styles.registerFormItem} name="firstname" label="First name">
          <Input id="UserProfile-FirstName_Input" placeholder="" disabled autoComplete="no" />
        </Form.Item>

        <Form.Item className={styles.registerFormItem} name="lastname" label="Last name">
          <Input id="UserProfile-LastName_Input" placeholder="" disabled autoComplete="no" />
        </Form.Item>
      </div>

      <Form.Item className={styles.registerFormItem} name="phone" label="Phone">
        <Input id="UserProfile-Phone_Input" autoComplete="no" placeholder="" disabled />
      </Form.Item>

      <Form.Item className={styles.registerFormItem} name="mobile" label="Mobile">
        <Input id="UserProfile-Mobile_Input" autoComplete="no" placeholder="" disabled />
      </Form.Item>
    </>
  );
};
